// Opens Agents → Skills on one thing from elsewhere (the top search's Skills section): a workspace
// skill, a marketplace hit's preview, or Discover's results for a query. SkillsPane consumes it.
import type { MarketplaceSkill } from "$lib/plugins/agents/types.js";

export type SkillsNavTarget =
  | { kind: "skill"; skillId: string }
  | { kind: "marketplace"; result: MarketplaceSkill }
  | { kind: "search"; query: string };

class SkillsNavController {
  request = $state<(SkillsNavTarget & { nonce: number }) | null>(null);
  private nonce = 0;

  open(target: SkillsNavTarget): void {
    this.request = { ...target, nonce: ++this.nonce };
  }

  // The pane takes the request once, so a remount never replays it.
  take(): SkillsNavTarget | null {
    const req = this.request;
    this.request = null;
    return req;
  }
}

export const skillsNav = new SkillsNavController();
